export const GAME_MODE = {
    CLASSIC: 'classic',
    COUNTRY: 'country',
    CUSTOM_AREA: 'custom_area',
};
export const SCORE_MODE = {
    NORMAL: 'normal',
    TIME: 'time',
};

export const AREA_MODE = {
    NOMINATIM: 'nominatim',
    POLYGON: 'polygon',
};

export const STROKE_COLORS = [
   '#b71c1c',
   '#33691e',
   '#f57f17',
   '#880e4f',
   '#01579b',   
];